export default __webpack_public_path__ + "static/media/warning--lane-closed-in-dual-lanes-right--g1.2df26f89.png";